export default {
  AS: {
    "footer.button.billOfMaterials": "Stückliste",
    "footer.button.export": "Export",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Vertrieb Kontaktieren",
    "footer.button.addToWatchlist": "Zur Merkliste Hinzufügen",
    "footer.button.requestQuote": "Angebot Anfragen",
    "header.configurator.title": "Konfigurator",

    "header.links.about.label": "über asecos",
    "header.links.about.url":
      "https://www.asecos.com/Ueber-asecos/Ueber-asecos/Ueber-asecos/DE_index_3187.html",
    "header.links.terms.label": "AGB",
    "header.links.terms.url": "https://www.asecos.com/AGB/DE_index_1724.html",
    "header.links.imprint.label": "Impressum",
    "header.links.imprint.url":
      "https://www.asecos.com/Impressum/DE_index_1438.html",
    "header.links.privacy.label": "Datenschutzrichtlinie",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/DE/DE/asecos/datenschutzhinweise",

    "dialog.requestQuote.title.success": "Anfrage Gesendet",
    "dialog.requestQuote.title.requestQuote": "Angebot Anfragen",
    "tab.billOfMaterials.title": "Stückliste",
    "tab.configurationSummary.title": "Zusammenfassung der Konfiguration",
    "dialog.requestQuote.title.contactData": "Kontaktdaten",
    "dialog.requestQuote.title.companyData": "Firmendaten",
    "dialog.requestQuote.label.salutation": "Anrede",
    "dialog.requestQuote.select.salutation.option.female": "Frau",
    "dialog.requestQuote.select.salutation.option.male": "Herr",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Vorname",
    "dialog.requestQuote.label.lastName": "Nachname",
    "dialog.requestQuote.label.email": "E-Mail",
    "dialog.requestQuote.label.phone": "Telefon",
    "dialog.requestQuote.label.company": "Firma",
    "dialog.requestQuote.label.country": "Land",
    "dialog.requestQuote.label.postalCode": "Postleitzahl",
    "dialog.requestQuote.label.city": "Ort",
    "dialog.requestQuote.label.street": "Straße",
    "dialog.requestQuote.label.number": "Nr.",
    "dialog.requestQuote.label.contactHours": "Ich bitte um einen Rückruf",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Vormittag",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Nachmittag",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Hier können sie ihren bevorzugten Fachhändler eintragen (sofern bekannt)",
    "dialog.requestQuote.label.specialistRetailer.salutation": "Anrede",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Frau",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Herr",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Firma",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Vorname",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Nachname",
    "dialog.requestQuote.label.specialistRetailer.email": "E-Mail",
    "dialog.requestQuote.label.specialistRetailer.city": "Ort",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos.com/Datenschutzhinweise/DE_index_1721.html",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos.com/dokumente/DSGVO/Einwilligungserklaerung_asecos_DE.pdf",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Ich habe die Hinweise zum <privacyLink>Datenschutz</privacyLink> gelesen und akzeptiere sie. Ferner bin ich mit der Verarbeitung, Nutzung und Weitergabe meiner Daten an einen Fachhändler gemäß <consentLink>Einwilligungserklärung</consentLink> einverstanden.",
    "dialog.requestQuote.label.comment": "Kommentar",
    "SubconfigurationNavigation.resetItem": "Gruppe zurücksetzen",
    "SubconfigurationNavigation.previousItem": "Zurück",
    "SubconfigurationNavigation.nextItem": "Weiter",
    "form.field.error.email": "Email ungültig",
    "form.field.error.phone": "Telefonnummer ungültig",
    "validation.required": "Dieses Feld ist erforderlich",
    "footer.button.save": "Speichern",
    "footer.button.load": "Laden",

    "dialog.requestQuote.success.message":
      "Vielen Dank für Ihr Interesse an asecos und unseren Produkten. Sie erhalten in den nächsten Minuten eine Bestätigung an Ihre angegebene E-Mail-Adresse inklusive Ihrer Konfigurationsdaten als PDF- und JSON-Datei. Mit letzterer können Sie über den Hochladen-Button Ihre Konfiguration erneut öffnen.\n\nasecos Produkte werden über autorisierte Fachhändler verkauft. Daher leiten wir Ihre Anfrage an einen geeigneten asecos Partner weiter. Dieser wird Ihnen ein unverbindliches Angebot gemäß Ihrer Konfiguration erstellen und gegebenenfalls zusätzlich Kontakt mit Ihnen aufnehmen.",
    "dialog.requestQuote.success.close": "Fenster schließen",
    "dialog.requestQuote.error.message":
      "Ein Fehler ist beim Senden Ihrer Anfrage aufgetreten. Bitte versuchen Sie es später erneut.",
  },
};
